import { render, staticRenderFns } from "./ConfiguracionDepartamentos.vue?vue&type=template&id=95dbb602&scoped=true"
import script from "./ConfiguracionDepartamentos.vue?vue&type=script&lang=js"
export * from "./ConfiguracionDepartamentos.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracionDepartamentos.vue?vue&type=style&index=0&id=95dbb602&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95dbb602",
  null
  
)

export default component.exports